var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0109 9.0918H15.4804V14.7618C15.4804 18.7527 12.2419 22.002 8.24021 22.002C4.24937 22.002 1 18.7636 1 14.7618V9.0918H1.0109Z",
    stroke: "#fff",
    strokeWidth: 1.40007,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4817 11.5332C17.3572 11.5332 18.8728 13.0598 18.8728 14.9352C18.8728 16.8107 17.3572 18.3263 15.4817 18.3263C15.1873 18.3263 14.882 18.2936 14.6094 18.2173",
    stroke: "#fff",
    strokeWidth: 1.40007,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88188 1C4.88188 1 3.44257 2.35209 4.88188 3.7805C6.3212 5.20891 4.88188 7.20433 4.88188 7.20433",
    stroke: "#fff",
    strokeWidth: 1.40007,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27251 1C8.27251 1 6.83319 2.35209 8.27251 3.7805C9.71183 5.20891 8.27251 7.20433 8.27251 7.20433",
    stroke: "#fff",
    strokeWidth: 1.40007,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6631 1C11.6631 1 10.2238 2.35209 11.6631 3.7805C13.1025 5.20891 11.6631 7.20433 11.6631 7.20433",
    stroke: "#fff",
    strokeWidth: 1.40007,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaWhite);
export default __webpack_public_path__ + "static/media/tea_white.f68e44daf933738f71c72a4636723707.svg";
export { ForwardRef as ReactComponent };